// Sticky Add to Cart - Mobile Enhancements
$(document).ready(function () {
  // Toggle expand/collapse variant selector
  $(document).on(
    "click",
    ".pro_sticky_atc .sticky_variant_collapsed",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $collapsed = $(this);
      var $expanded = $collapsed.siblings(".sticky_variant_expanded");

      // Sync with main product form before opening
      if (!$collapsed.hasClass("is-open")) {
        syncStickyBarWithMainForm();
      }

      // Toggle open state
      $collapsed.toggleClass("is-open");
      $expanded.toggleClass("is-open");
    }
  );

  // Function to sync sticky bar with main form selection
  function syncStickyBarWithMainForm() {
    // Find main form - try multiple selectors
    var $mainForm = $("#AddToCartForm").first();
    if (!$mainForm.length) {
      $mainForm = $("form[action*='/cart/add']").first();
    }
    if (!$mainForm.length) {
      $mainForm = $(".product-single__form").first();
    }

    var allSelectedOptions = [];

    // Sync each option
    $(".pro_sticky_atc .sticky_variant_expanded .swatch").each(function () {
      var $swatch = $(this);
      var optionIndex = $swatch.data("option-index");

      // Find corresponding main form swatch
      var $mainSwatch = $mainForm.find(
        '.swatch[data-option-index="' + optionIndex + '"]'
      );

      if ($mainSwatch.length) {
        var $checkedMainRadio = $mainSwatch.find('input[type="radio"]:checked');

        if ($checkedMainRadio.length) {
          var selectedValue = $checkedMainRadio.val();

          // Check corresponding radio in sticky bar
          var $stickyRadio = $swatch.find(
            'input[type="radio"][value="' + selectedValue + '"]'
          );

          if ($stickyRadio.length) {
            $stickyRadio.prop("checked", true);
          }

          // Collect selected option info
          var optionName = $swatch.find(".header").text().split(":")[0].trim();
          var isColorOption = $swatch.find(".swatch-element.color").length > 0;

          allSelectedOptions.push({
            name: optionName,
            value: selectedValue,
            isColor: isColorOption,
          });
        }

        // Force lazyload for all color swatch images in sticky bar
        $swatch.find(".swatch-element.color label.lazyload").each(function () {
          var $label = $(this);
          var dataSrc = $label.attr("data-src");
          if (dataSrc && !$label.hasClass("lazyloaded")) {
            var bgImage = $label.css("background-image");
            if (!bgImage || bgImage === "none") {
              $label.css("background-image", "url(" + dataSrc + ")");
              $label.addClass("lazyloaded");
            }
          }
        });
      }
    });

    // Update collapsed label with all selected options
    updateCollapsedLabelWithAllOptions(allSelectedOptions);

    // Update expanded headers for each option
    allSelectedOptions.forEach(function (option, index) {
      var $optionSwatch = $(
        ".pro_sticky_atc .sticky_variant_expanded .swatch"
      ).eq(index);
      var $optionHeader = $optionSwatch.find(".header");

      if (option.isColor) {
        // For color option, add color box to header
        var colorValue = option.value.toLowerCase().trim();
        var tempEl = $("<div>").css("color", colorValue).appendTo("body");
        var computedColor = tempEl.css("color");
        tempEl.remove();

        var colorBoxHTML =
          '<span class="sticky-color-box-inline" style="background-color:' +
          computedColor +
          ';"></span>';
        $optionHeader.html(
          option.name +
            ": " +
            colorBoxHTML +
            '<span class="sticky-current-value">' +
            option.value +
            "</span>"
        );
      } else {
        // For non-color options, just show option name
        $optionHeader.text(option.name + ": " + option.value);
      }
    });
  }

  // Update collapsed label with all selected options
  function updateCollapsedLabelWithAllOptions(allSelectedOptions) {
    if (allSelectedOptions.length === 0) return;

    var $collapsed = $(".pro_sticky_atc .sticky_variant_collapsed");
    var $label = $collapsed.find(".sticky_variant_label");

    var labelParts = [];

    allSelectedOptions.forEach(function (option) {
      if (option.isColor) {
        // For color option, add color box
        var colorValue = option.value.toLowerCase().trim();
        var tempEl = $("<div>").css("color", colorValue).appendTo("body");
        var computedColor = tempEl.css("color");
        tempEl.remove();

        var colorBoxHTML =
          '<span class="sticky-color-preview-box" style="background-color:' +
          computedColor +
          ';"></span>';
        labelParts.push(option.name + ": " + colorBoxHTML + option.value);
      } else {
        // For non-color options, just show value
        labelParts.push(option.value);
      }
    });

    // Join all parts with " | "
    $label.html(labelParts.join(' <span class="sticky-separator">|</span> '));
  }

  // Update sticky bar collapsed label
  function updateStickyCollapsedLabel(selectedValue, $swatch) {
    var $collapsed = $(".pro_sticky_atc .sticky_variant_collapsed");
    var $label = $collapsed.find(".sticky_variant_label");
    var $swatchHeader = $swatch.find(".header");

    // Get option name from header text or data attribute
    var optionName = $swatchHeader.text().split(":")[0].trim();
    if (!optionName) {
      optionName =
        $swatch.find(".swatch-element:first label").attr("for") || "";
      optionName = optionName.split("-")[0];
    }

    // Check if this is a color option by checking if swatch has .color class
    var isColorOption = $swatch.find(".swatch-element.color").length > 0;

    if (isColorOption && selectedValue) {
      // Convert color name to CSS color
      var colorValue = selectedValue.toLowerCase().trim();
      var tempEl = $("<div>").css("color", colorValue).appendTo("body");
      var computedColor = tempEl.css("color");
      tempEl.remove();

      // Update collapsed label: "Color: [box] Orange"
      var colorBoxHTML =
        '<span class="sticky-color-preview-box" style="background-color:' +
        computedColor +
        ';"></span>';
      $label.html(optionName + ": " + colorBoxHTML + selectedValue);

      // Update expanded header: "Color: [box] Orange"
      var expandedColorBoxHTML =
        '<span class="sticky-color-box-inline" style="background-color:' +
        computedColor +
        ';"></span>';
      $swatchHeader.html(
        optionName +
          ": " +
          expandedColorBoxHTML +
          '<span class="sticky-current-value">' +
          selectedValue +
          "</span>"
      );
    } else {
      // For non-color options, just show the value
      $label.text(selectedValue);
    }
  }

  // Listen to main form variant changes
  $(document).on(
    "change",
    "#AddToCartForm .swatch input[type='radio'], #product-selectors",
    function () {
      setTimeout(syncStickyBarWithMainForm, 100);
    }
  );

  // Sync on page load
  $(document).ready(function () {
    setTimeout(syncStickyBarWithMainForm, 500);
  });

  // Close when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".sticky_variant_wrapper").length) {
      $(".pro_sticky_atc .sticky_variant_collapsed").removeClass("is-open");
      $(".pro_sticky_atc .sticky_variant_expanded").removeClass("is-open");
    }
  });

  // Swatch label click handler (for radio inputs from main section structure)
  $(document).on(
    "click",
    ".pro_sticky_atc .sticky_variant_expanded .swatch-element label",
    function (e) {
      var $label = $(this);
      var $radio = $label.prev('input[type="radio"]');
      var selectedValue = $radio.val();
      var $swatch = $label.closest(".swatch");
      var $optionContainer = $label.closest(".swatch");

      // Get all selected options from all swatches
      var selectedOptions = [];
      $(".pro_sticky_atc .sticky_variant_expanded .swatch").each(function () {
        var $checkedRadio = $(this).find('input[type="radio"]:checked');
        if ($checkedRadio.length) {
          selectedOptions.push($checkedRadio.val());
        }
      });

      // Find matching variant and update
      var $form = $label.closest("form");
      var $hiddenInput = $form.find('input[name="id"]');
      var $collapsed = $label
        .closest(".sticky_variant_wrapper")
        .find(".sticky_variant_collapsed");
      var $labelCollapsed = $collapsed.find(".sticky_variant_label");

      // Find matching variant in main selector
      var optionSelector = "#product-selectors option";
      var matchingVariant = null;
      var matchingTitle = "";

      $(optionSelector).each(function () {
        var $option = $(this);
        var optionText = $option.text().toLowerCase();
        var allMatch = selectedOptions.every(function (val) {
          return optionText.includes(val.toLowerCase());
        });

        if (allMatch && !$option.is(":disabled")) {
          matchingVariant = $option.val();
          matchingTitle = $option.text();
          return false; // break loop
        }
      });

      if (matchingVariant) {
        // Update hidden input
        $hiddenInput.val(matchingVariant);

        // Collect all selected options to update collapsed label
        var allSelectedOptions = [];
        $(".pro_sticky_atc .sticky_variant_expanded .swatch").each(function () {
          var $sw = $(this);
          var $checkedRadio = $sw.find('input[type="radio"]:checked');
          if ($checkedRadio.length) {
            var optionName = $sw.find(".header").text().split(":")[0].trim();
            var isColorOption = $sw.find(".swatch-element.color").length > 0;
            allSelectedOptions.push({
              name: optionName,
              value: $checkedRadio.val(),
              isColor: isColorOption,
            });
          }
        });

        // Update collapsed label with all options
        updateCollapsedLabelWithAllOptions(allSelectedOptions);

        // Update expanded headers for each option
        allSelectedOptions.forEach(function (option) {
          var $optionSwatch = $(
            ".pro_sticky_atc .sticky_variant_expanded .swatch"
          ).eq(allSelectedOptions.indexOf(option));
          var $optionHeader = $optionSwatch.find(".header");

          if (option.isColor) {
            // For color option, add color box to header
            var colorValue = option.value.toLowerCase().trim();
            var tempEl = $("<div>").css("color", colorValue).appendTo("body");
            var computedColor = tempEl.css("color");
            tempEl.remove();

            var colorBoxHTML =
              '<span class="sticky-color-box-inline" style="background-color:' +
              computedColor +
              ';"></span>';
            $optionHeader.html(
              option.name +
                ": " +
                colorBoxHTML +
                '<span class="sticky-current-value">' +
                option.value +
                "</span>"
            );
          } else {
            // For non-color options, just show option name
            $optionHeader.text(option.name + ": " + option.value);
          }
        });

        $collapsed.data("variant-id", matchingVariant);

        // Sync with main product form
        $("#product-selectors").val(matchingVariant).trigger("change");

        // Auto-close after selection
        $collapsed.removeClass("is-open");
        $label.closest(".sticky_variant_expanded").removeClass("is-open");
      }
    }
  );

  // Prevent sticky form redirect - use existing AJAX system
  $("#sticky_add_to_cart").on("submit", function (e) {
    e.preventDefault();

    var $form = $(this);
    var $button = $form.find(".sticky_pro__cart");
    var formId = $form.attr("id");
    var productId = $form.find('input[name="id"]').val();

    // Remove focus immediately to prevent stuck hover state
    $button.blur();

    // Show loading state
    showButtonState($button, "loading");

    // Use existing Shopify ajax cart system
    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.addItemFromFormStart === "function"
    ) {
      // Override or listen to the completion
      Shopify.addItemFromFormStart(formId, productId);

      // Assume success after a delay (since we can't easily hook into the callback)
      setTimeout(function () {
        showButtonState($button, "success");
        setTimeout(function () {
          showButtonState($button, "default");
        }, 3000);
      }, 1000);
    } else {
      // Fallback to standard ajax add
      var formData = {
        id: productId,
        quantity: $form.find('input[name="quantity"]').val() || 1,
      };

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: formData,
        dataType: "json",
        success: function (item) {
          // Show success state
          showButtonState($button, "success");

          // Trigger cart update
          $(document).trigger("cart:updated");

          // Update cart count if drawer exists
          if ($("#CartCount").length) {
            ShopifyAPI.getCart(function (cart) {
              $("#CartCount").text(cart.item_count);
            });
          }

          // Return to default after 3s
          setTimeout(function () {
            showButtonState($button, "default");
          }, 3000);
        },
        error: function (xhr) {
          var error = "Could not add item to cart";
          if (xhr.responseJSON && xhr.responseJSON.description) {
            error = xhr.responseJSON.description;
          }

          // Show error and return to default
          showButtonState($button, "default");
          alert(error);
        },
      });
    }

    return false;
  });

  // Button state management
  function showButtonState($button, state) {
    var $iconWrapper = $button.find(".d-inline.d-sm-none, svg").parent();
    if (!$iconWrapper.length) {
      $iconWrapper = $button;
    }

    if (state === "loading") {
      $button.prop("disabled", true).addClass("is-loading");

      // Hide existing icons and text with class
      $button
        .find("svg:not(.loading-spinner):not(.success-icon)")
        .addClass("hidden-icon");
      $button.find(".d-inline.d-sm-none").addClass("hidden-icon");
      $button.find(".d-none.d-sm-inline").addClass("hidden-icon");

      // Add loading spinner with exact loading.io structure
      if (!$button.find(".ldio-spinner").length) {
        $button.append('<div class="ldio-spinner"><div></div></div>');
      }
    } else if (state === "success") {
      $button.removeClass("is-loading").addClass("is-success");

      // Remove loading spinner
      $button.find(".ldio-spinner").remove();

      // Hide original icon and text
      $button.find("svg:not(.success-icon)").addClass("hidden-icon");
      $button.find(".d-none.d-sm-inline").addClass("hidden-icon");

      // Replace with checkmark
      if (!$button.find(".success-icon").length) {
        $button.append(`
          <svg class="success-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        `);
      }
    } else {
      // default state
      $button.prop("disabled", false).removeClass("is-loading is-success");

      // Remove loading and success icons
      $button.find(".ldio-spinner, .success-icon").remove();

      // Show original icon and text
      $button.find("svg").removeClass("hidden-icon");
      $button.find(".d-inline.d-sm-none").removeClass("hidden-icon");
      $button.find(".d-none.d-sm-inline").removeClass("hidden-icon");

      // Remove hover/focus state on mobile
      $button.blur();
    }
  }
});
